import { Injectable } from '@angular/core';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class GameHistoryService {
  private customer;
  constructor(
    private userSession:UserSessionService,
    private webservice: WebservicesService,
    ) { 
    this.userSession.getCustomer().subscribe(
      (customer) => {
          this.customer = customer;
      }
  );
  }

  public callCasinoGameHistory(date_from: string, date_to: string, page: number = 1, type?: string) {
    let obj: any = {
        customer_id: this.customer.customerId,
        session_token: this.userSession.sessionToken,
        date_from: date_from,
        date_to: date_to,// + " 23:59:59", //Shouldn't need this time part.
        page: page,
        type: type
        //num: 25
    }

    return this.webservice.get('games/casino-game-history', obj);
}

public sendCasinoGameDetails(id: string,gameName: string, host: string, connect: string, disconnect: string) {
  let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      game_name: gameName,
      id: id,
      host: host,
      connect: connect,
      disconnect: disconnect
  }

  return this.webservice.post('games/send-casino-game-hands-history', obj);
}

public callCasinoGameDetails(id: string, host: string, connect: string, disconnect: string, page:number = 1) {
  let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      id: id,
      host: host,
      connect: connect,
      disconnect: disconnect,
      page:page
  }

  return this.webservice.get('games/casino-game-hands-history', obj);
}

public getExternalGameTransactions(data, page:number = 1, vendor) {
  let obj: any = {
      customer_id: this.customer.customerId,
      game_session_id: data.id,
      session_token: this.userSession.sessionToken,
      vendor: vendor,
      num: '', 
      page:page
  }

  return this.webservice.get('games/get-external-game-transactions', obj);
}

public openIAB(url, target, options) {
  window.cordova.InAppBrowser.open(url,target,options);
}

}
